<template>
  <div class="app-container post-list">
    <div class="post-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="post-list-filter-value" v-model.trim="search.keywords" @keyup.enter.native="searchChange" placeholder="内容标题/内容正文" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="post-list-filter-value" v-model.trim="search.postedByName" @keyup.enter.native="searchChange" placeholder="官方号名称或发布者姓名" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="分类" v-model="search.parentTagId" @change="onChangeParentTagId" clearable size="small">
              <el-option
                v-for="item in search.parentTagOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="话题" v-model="search.tagId" clearable size="small">
              <template v-if="getRelatedTags(search.parentTagId)">
                <el-option
                  v-for="item in search.tagOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </template>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="post-list-filter-date"
              v-model="search.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="内容类别" v-model="search.postType" clearable size="small">
              <el-option
                v-for="item in postTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="是否官方号发布" v-model="search.isAdminPost" clearable size="small">
              <el-option
                v-for="item in adminPostOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col> -->
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="是否已下架" v-model="search.isBannedPost" clearable size="small">
              <el-option
                v-for="item in bannedPostOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="post-list-filter-value" v-model.trim="search.banComment" @keyup.enter.native="searchChange"
             placeholder="下架原因" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div>
            <el-button class="post-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="post-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class = "post-list-container">
      <avue-crud ref="crud"
                 :option="postTableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 :before-open="handleOpenBefore"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">

        <template slot="title"
                  slot-scope="scope">
          <div class="title">
            <div class="post-cover-image" v-if="!scope.row.isVideoPost && scope.row.coverImg" v-viewer>
              <img v-for="(src, index) in scope.row.attachments" :key="index" :src="src.attachmentUrl" :class="{'hide-redundant-post-images': index > 0 }">
            </div>
            <div class="post-cover-image" v-if="scope.row.isVideoPost && scope.row.coverImg">
              <img :src="scope.row.coverImg" @click="viewVideo(scope.row.attachments[0].attachmentUrl,scope.row.attachments[0].convertStreamUrl)">
            </div>
            <a href="javascript:void(0);" @click="handleView(scope.row,scope.index);"
                class="post-list-container-button">
              {{scope.row.title}}
            </a>
          </div>
        </template>
        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.content_list_add">新增内容</el-button>
          <el-button  
                     v-if="permissions.content_export"
                     class="filter-item"
                     @click="handleExport()"
                     size="small"
                     type="primary"
                     :loading="exportLoading"
                     icon="el-icon-download">{{exportName}}
          </el-button>
        </template>
        <template slot="parentTags"
                  slot-scope="scope">
              {{scope.row.parentTags}}
        </template>
        <template slot="tags"
                  slot-scope="scope">
              {{scope.row.tags}}
        </template>
        <template slot="menu"
                  slot-scope="scope" width=100>
          <el-button size="mini"
            type="text"
            icon="el-icon-view"
            title="查看"
            @click="handleView(scope.row,scope.index)">查看
          </el-button>
          <el-button size="mini"
            type="text"
            icon="el-icon-mobile-phone"
            title="预览"
            @click="openQrCodeDialog(scope.row.id)">预览
          </el-button>
          <el-button size="mini"
                v-if="permissions.content_list_update && scope.row.canEdit"
                type="text"
                icon="el-icon-edit"
                title="编辑"
                @click="handlePostUpdate(scope.row,scope.index)">编辑
          </el-button>
          <el-button size="mini"
                type="text"
                icon="el-icon-upload2"
                title="上架"
                v-if="permissions.content_list_up && scope.row.isBanned"
                @click="handleUp(scope.row,scope.index)">上架
          </el-button>
          <el-button size="mini"
                type="text"
                icon="el-icon-download"
                title="下架"
                v-if="permissions.content_list_down && !scope.row.isBanned"
                @click="handleDown(scope.row,scope.index)">下架
          </el-button>
          <el-button type="text"
            v-if="permissions.content_list_delete && scope.row.canEdit"
            icon="el-icon-delete"
            size="mini"
            title="删除"
            @click="handleDelete(scope.row)">删除</el-button>
          <el-button type="text"
            v-if="!permissions.content_list_delete && permissions.content_list_self_delete && scope.row.canEdit && scope.row.isCreatedByAdminSelf"
            icon="el-icon-delete"
            size="mini"
            title="删除"
            @click="handleDelete(scope.row, true)">删除</el-button>
          <el-button type="text"
            icon="icon-hot"
            size="mini"
            title="编辑热度值"
            v-if="permissions.post_edit_heat"
            @click="openManualDialog(scope.row)">热度</el-button>
          <!-- <el-button
            title="复制链接"
            size="mini"
            type="text"
            icon="el-icon-share"
            style="font-size: 20px;"
            @click="copyLink(scope.row)"></el-button> -->
        </template>

      </avue-crud>
    </basic-container>
    <el-dialog
      title="请使用微信扫描预览二维码"
      :visible.sync="qrCodeDialogVisible"
      width="35%"
      center>
      <span slot="footer" class="dialog-footer">
       <el-row>
          <div class="qr-code">
            <vue-qr :text="qrCodeValue" size="300"></vue-qr>
          </div>
          <p class="qr-code-url">链接地址</p>
          <p class="qr-code-url">{{qrCodeValue}}</p>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="请使用微信扫描预览二维码"
      :visible.sync="qrCodeDialogVisible"
      width="40%"
      center>
      <span slot="footer" class="dialog-footer">
       <el-row>
        <div class="qr-code1">
        <div class="qr-code-content">
          <div class="qr-code-img">
            <vue-qr :text="qrCodeZhValue" size="150"></vue-qr>
          </div>
          <p class="qr-code-url">中文预览</p>
        </div>
        <div class="qr-code-content">
          <div class="qr-code-img">
            <vue-qr :text="qrCodeEnValue" size="150"></vue-qr>
          </div>
          <p class="qr-code-url">英文预览</p>
        </div>
        </div>
        <p class="qr-code-url">链接地址</p>
        <p class="qr-code-url">中文：{{qrCodeZhValue}}</p>
        <p class="qr-code-url">英文：{{qrCodeEnValue}}</p>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑热度值"
      :visible.sync="manualDialogVisible"
      width="30%">
      <template>
        <div>
          <label class="manual-input-label">热度值</label>
          <el-input-number
            v-model="manualValue"
            :step="1"
            :precision="2"
            :min="0"
            @change="checkManualValue()">
          </el-input-number>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="manualDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateManual()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="下架"
      :visible.sync="banDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="down-dialog-item-label">下架原因</el-label>
          <el-input v-model="banDialogComment"></el-input>
        </div>
        <div>
          <!-- <el-checkbox class="down-dialog-item-label" v-model="banDialogIsSendWx">是否发送消息通知</el-checkbox> -->
          <el-input type="textarea" :rows="3" v-if="banDialogIsSendWx" v-model="banDialogSendWxMessage" placeholder="消息"></el-input>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="banDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDownSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible="videoPlayDialogVisible" width="40%" class="handle-dialog" @close="closeVideo">
      <video-player
        class="vjs-mc-skin"
        :playsinline="true"
        :options="playerOption"
        ref="videoPlayer">
      </video-player>
    </el-dialog>
  </div>
</template>

<script>
  import {fetchPostList, updatePostBanStatus, removePost, removeSelfPost, updateManualHeatValue, exportPost } from '@/api/post/post'
  import {fetchRelateItemList, fetchItemList} from '@/api/basic/tagtype'
  import {getAllClassification} from '@/api/basic/classification'
  import {listTableOption} from '@/const/crud/content/list'
  import circleEnum from '@/common/enums/defaultCircle';
  import {mapGetters} from "vuex";
  import { exporting } from '@/util/exportUtil';
  import vueQr from 'vue-qr';

  export default {
    name: "table_post",
    data() {
      return {
        adminPostOptions: [
          { label: '是', value: 1 },
          { label: '否', value: 0 },
        ],
        postTypeOptions: [
          { label: '图文', value: 0 },
          { label: '视频', value: 1 },
        ],
        bannedPostOptions: [
          { label: '是', value: 1 },
          { label: '否', value: 0 },
        ],
        exportName: "导出",
        exportLoading: false,
        videoPlayDialogVisible: false,
        playerOption: {
          height: '380',
          autoplay: false,
          muted: false,
          loop: false,
          language: 'zh-CN',
          playbackRates: [1.0, 1.5, 2.0],
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          sources: [],
        },
        search: {
          current: 1,
          size: 10,
          postedByName: "",
          searchTime: [],
          sortField: "",
          sortPolicy: "",
          expired: "",
          postType: "",
          tag: "",
          keywords: "",
          parentTagId: -1,
          tagId: "",
          banComment: "",
          parentTagOptions: [],
          tagOptions: [],
          blankTags: [],
          preParentTagId: "",
          isAdminPost: "",
          isBannedPost: "",
        },

        // 列表页面
        tableData:[],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        tableLoading: false,
        postTableOption: listTableOption,
        circleId: 1, // 1-广场
        allTags: [],
        manualDialogVisible: false,
        manualValue : 0,
        banDialogVisible: false,
        banDialogComment: "",
        banDialogIsSendWx: false,
        banDialogSendWxMessage: "",
        banDialogRow: 0,
        qrCodeDialogVisible: false,
        qrCodeZhValue: '',
        qrCodeEnValue: '',
      };
    },
    async activated() {
      await this.getRelatedTagOptionse();
      this.queryPosts();
    },
    async created () {
      await this.getRelatedTagOptionse();
      this.queryPosts();
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 0) {
          return this.search.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 1) {
          return this.search.searchTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      openQrCodeDialog(id) {
        this.qrCodeDialogVisible = true;
        this.qrCodeZhValue = process.env.VUE_APP_BASIC_PAGE_PATH + `/post-preview/${id}?lang=zh`;
        this.qrCodeEnValue = process.env.VUE_APP_BASIC_PAGE_PATH + `/post-preview/${id}?lang=en`;
      },
      onChangeParentTagId() {
        if (!this.search.parentTagId) {
          this.search.tagId = "";
        }
      },
      formatData(records) {
        // 帖子列表格式化
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (record.postedBy) {
              record.postedByName = record.postedBy.name
              record.postedByRealname = record.postedBy.realname
              const isOfficial = record.postedBy.memberType == 1;
              record.canEdit = isOfficial && record.isBanned;
              if (record.postedByName == "") {
                record.postedByName = "--"
              }
              if (record.postedByRealname == "") {
                record.postedByRealname = "--"
              }
              if (isOfficial) {
                record.postedByRealname = record.postedBy.relatedPersonalRealname;
              }
            }
            if(!record.title) {
              record.title = "--"
            }
            if (!record.commentCount) {
              record.commentCount = 0
            }
            if (!record.favoriteCount) {
              record.favoriteCount = 0
            }
            if (!record.likeCount) {
              record.likeCount = 0
            }
            if (!record.viewedCount) {
              record.viewedCount = 0
            }

            if (!record.finalHeatValue) {
              record.finalHeatValue = 0;
            }
            if (!record.manualHeatValue) {
              record.manualHeatValue = 0;
            }
            if (!record.banComment){
              record.banComment = "--"
            }
            record.isNotBanned = record.isBanned ? '是' : '否';
            record.isVideoPost = record.postType === 1;
            record.postType = record.postType == 0 ? '图文' : '视频';
            record.tags = Array.from(new Set(record.postTags.map(item => {return item.tagName}))).join('、');
            record.parentTags = Array.from(new Set(record.postTags.filter(item => !!item.parentTagName).map(item => {return item.parentTagName}))).join('、');
          })
        }
        return records
      },
      getParameter(param){
        // 提取url参数值
        let url = location.href
        let reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)")
        let r = url.substr(url.indexOf("\?") + 1).match(reg)
        if (r != null) return unescape(r[2])
        else return null
      },
      getParams() {
        let params={
          circleId: this.circleId,
          current: this.search.current,
          size: this.search.size
        }
        // 增加搜索功能
        if(this.search.keywords!=""&&this.search.keywords.trim()!="")
          params.keywords=this.search.keywords
        if(this.search.postedByName!=""&&this.search.postedByName.trim()!="")
          params.postedByName=this.search.postedByName
        if(this.search.postType!==null&&this.search.postType!=="")
          params.postType=this.search.postType
        if(this.search.tagId!==null&&this.search.tagId!=="")
          params.tagId=this.search.tagId
        if(this.search.parentTagId!==null&&this.search.parentTagId!==""&&this.search.parentTagId!==-1&&!this.search.tagId) {
          params.parentTagId=this.search.parentTagId
        }
        if(this.search.isAdminPost!==null&&this.search.isAdminPost!=="")
          params.memberType=this.search.isAdminPost? 1:0
        if(this.search.isBannedPost!==null&&this.search.isBannedPost!=="")
          params.isBanned=this.search.isBannedPost

        if(this.startTime&&this.endTime) {
          params.postStartTime=this.startTime
          let t=new Date(this.endTime)
          t.setDate(t.getDate()+1)
          params.postEndTime=t.getFullYear()+'-'+(t.getMonth()+1)+'-'+t.getDate()
        } else {
          params.postStartTime=null
          params.postEndTime=null
        }
        if(this.search.banComment!=""&&this.search.banComment.trim()!="")
          params.banComment=this.search.banComment
        // 增加排序功能
        if(this.search.sortField!=""&&this.search.sortField.trim()!="")
          params.sortField=this.search.sortField
        else
          params.sortField="post_time"
        if(this.search.sortPolicy!=""&&this.search.sortPolicy.trim()!="")
          params.sortPolicy=this.search.sortPolicy
        else
          params.sortPolicy="desc"
        return params
      },
      getList() {
        // 获取帖子列表
        let params = this.getParams()

        this.tableLoading = true
        fetchPostList(params).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      async getRelatedTagOptionse() {
        const response = await getAllClassification();
        if (Array.isArray(response.data.data)) {
          const tags = response.data.data.map(x => {
            return {
              value: x.id,
              label: x.name
            }
          });
          this.search.parentTagOptions = [{value: -1, label: '全部'}].concat(tags);
        }
        const result = await this.requestWrapper(fetchItemList, {type: 3, size: 9999 });
        if (result.ok) {
          if (result.data && result.data.records) {
            const allTags = [];
            result.data.records.forEach((record) => {
              allTags.push({
                value: record.id,
                label: record.name,
              });
            });
            this.allTags = allTags;
          }
        }
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.keywords = "";
        this.search.postedByName = ""
        this.search.searchTime = []
        this.search.isAdminPost = ""
        this.search.tagId = "";
        this.search.parentTagId = "";
        this.search.tagOptions = [];
        this.search.postedByName = "";
        this.search.postType = "";
        this.search.banComment= "";
        this.search.isBannedPost = "";
        this.searchChange()
      },
      toMemberDetail(postedById) {
        // 帖子详情里点击发布者姓名，链接转到该发布者的会员详情
        this.$router.push({
          path: "/upms/member/detail/" + postedById,
        })
      },
      toCircleDetail(circleId) {
        // 帖子详情里点击圈子名称，链接转到该圈子的详情页面
        this.$router.push({
          path: "/post/circle/detail/" + circleId,
        })
      },
      toCommentList(curPostId) {
        // 帖子详情里点击评论数，链接转到该帖子的评论列表
        this.$router.push({
          path: "/post/comment",
          query: {
            postId: curPostId
          }
        })
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.search.size = val
        this.getList()
      },
      handleSortChange(val) {
        // 检查排序对象
        if (val.prop == "commentCount") {
          this.search.sortField = "comment_count"
        } else if (val.prop == "favoriteCount") {
          this.search.sortField = "favorite_count"
        } else if (val.prop == "likeCount") {
          this.search.sortField = "like_count"
        } else if (val.prop == "viewedCount") {
          this.search.sortField = "viewed_count"
        } else if (val.prop == "postTime"){
          this.search.sortField = "post_time"
        } else if (val.prop == "finalHeatValue"){
          this.search.sortField = "final_heat_value"
        } else if (val.prop == "manualHeatValue"){
          this.search.sortField = "manual_heat_value"
        } else {
          this.search.sortField = ""
        }
        // 检查排序方式
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc"
        } else {
          this.search.sortPolicy = ""
        }
        this.getList()
      },
      handleView(row, index) {
        if (row.id){
          this.$router.push({
            path: `/content/list/detail/${row.id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该帖子不存在',
            type: 'warning'
          })
        }
      },
      getPostDTO(row, inputIsBanned){
        let postDTO= {
          id: row.id,
          isBanned: inputIsBanned,
        }
        return postDTO
      },
      handleUp(row, index) {
        // 上架功能
        let postDTO = this.getPostDTO(row, 0)
        let _this = this
        this.$confirm('是否确认上架该标题为"' + row.title + '"'+ '的帖子?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return updatePostBanStatus(postDTO);
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '上架成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      handleDown(row, index) {
        this.banDialogRow = row;
        this.banDialogComment = "";
        this.banDialogIsSendWx = false;
        this.banDialogSendWxMessage = "你发布的图片或视频未能通过系统审核，请重新审核发布内容";
        this.banDialogVisible = true;
      },
      handleDownSubmit() {
        if (!this.banDialogComment) {
          this.$message({
            showClose: true,
            message: '下架原因不能为空',
            type: 'error'
          });
          return;
        }

        if (this.banDialogIsSendWx && !this.banDialogSendWxMessage) {
          this.$message({
            showClose: true,
            message: '发送消息不能为空',
            type: 'error'
          });
          return;
        }

        let postDTO = this.getPostDTO(this.banDialogRow, 1);
        postDTO.banComment = this.banDialogComment;
        postDTO.isSendWxMessage = this.banDialogIsSendWx;
        postDTO.wxMessage = this.banDialogSendWxMessage;
        updatePostBanStatus(postDTO)
          .then(response => {
            this.getList();
            this.$message({
              showClose: true,
              type: 'success',
              message: '下架成功'
            });
          })
          .catch(function () {})
          .finally(() => {
            this.banDialogVisible = false;
          });
      },
      handleOpenBefore(show, type) {
        show();
      },
      handleAdd() {
        this.$router.push({path: `/content/list/add?circleId=${circleEnum.HOME.circleId}`})
      },
      openManualDialog(row) {
        this.manualDialogVisible = true
        this.manualValue = row.manualHeatValue
        this.postId = row.id
      },
      copyLink(row) {
        let url = process.env.VUE_APP_BASIC_PAGE_PATH + `/post/${row.id}`
        if (row.isVideoPost) {
          url = process.env.VUE_APP_BASIC_PAGE_PATH + `/share/video/${row.id}`
        }
        this.$copyText(url).then(
          res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '已成功复制'
            })
          },
          err => {
            this.$message({
              showClose: true,
              type: 'error',
              message: '失败'
            })
          }
        )
      },
      updateManual() {
        let params = {
          id: '',
          manual: '',
        }
        params.id = this.postId
        params.manual = this.manualValue
        if (this.manualValue > 99999999) {
          this.$message({
            showClose: true,
            message: '初始值范围为0-99999999',
            type: 'error'
          })
          return
        }
        updateManualHeatValue(params).then((res) => {
          if (res.data.data) {
            this.manualDialogVisible = false
            this.getList()
          }
        })
      },
      checkManualValue() {
        if (this.manualValue > 99999999) {
          this.$message({
            showClose: true,
            message: '初始值范围为0-99999999',
            type: 'error'
          })
        }
      },
      handleDelete(row, isSelf) {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const requestMethod = !isSelf ? removePost: removeSelfPost;
          requestMethod(row.id).then(response => {
            if (response.data.data) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList()
            }
          }).catch(error => {
            this.$message({
              message: '删除失败',
              type: 'error'
            })
          })
        })
      },
      handlePostUpdate(row) {
        this.$router.push({path: '/content/list/edit', query: {id: row.id, circleId: circleEnum.HOME.circleId}})
      },
      queryPosts() {
        if (this.$route.query.date !== undefined) {
          this.search.searchTime.push(this.$route.query.date, this.$route.query.date)
        }
        this.getList()
      },
      // 获取与帖子类别相关的主题
      async getRelatedTags(tagId) {
        let _this = this
        if (! tagId) {
          _this.search.tagOptions = _this.search.blankTags;
          return;
        }
        if (tagId === -1) {
          _this.search.tagOptions = _this.allTags;
          return;
        }
        if (_this.search.preParentTagId == tagId) return true
        _this.search.tagId = "";
        _this.search.preParentTagId = tagId;
        const response = await fetchRelateItemList({size: 9999}, tagId);
        if (Array.isArray(response.data.data.records)) {
          _this.search.tagOptions = response.data.data.records.map(x => {
            return {
              value: x.id,
              label: x.name
            }
          })
        }
      },
      viewVideo(attachmentUrl, convertStreamUrl) {
        const src = !convertStreamUrl ? attachmentUrl: convertStreamUrl;
        if (this.playerOption.sources.length === 0) {
          this.playerOption.sources[0] = { src }
        } else {
          this.$refs.videoPlayer.player.src(src);
        }
        this.videoPlayDialogVisible = true;
      },
      closeVideo() {
        this.$refs.videoPlayer.player.pause();
        this.videoPlayDialogVisible = false;
      },
      handleExport() {
        let params = this.getParams()
        exportPost(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportLoading = true
            this.exportName = "导出中..."
            exporting(response.data.data, this.exportCallback)
          } else {
            this.$message({
              message: '信息导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportCallback(result) {
        this.exportLoading = false
        this.exportName = "导出"
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
            })
        }
      },
    }
  };

</script>


<style lang="scss" scoped>

.post-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: 96% !important;
    }
    &-date {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
/deep/.el-dialog__body {
  padding : 10px 20px 10px 20px;
}
/deep/.el-input-number {
  line-height: 36px;
}

.title {
  display: flex;
  align-items: center;
  .post-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}

.post-top-dialog {
  height: 90px;
  &-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    &-label {
      font-size: 15px;
      color: #606266;
      padding: 10px;
    }
    &-content {
      width: 200px !important;
    }
    &-tip {
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
      margin-top: 6px;
    }
    &-value {
      width: 200px;
    }
  }
}
.manual-input-label{
    font-size: 15px;
    color: #606266;
    padding: 10px;
}
.hide-redundant-post-images {
  display: none;
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
.qr-code1 {
  display: flex;
  .qr-code-content {
    flex: 1;
    .qr-code-img {
      width: 150px;
      height: 150px;
      margin: 0 auto;
      padding: 12px;
      border: 1px solid rgb(230, 230, 230);
      border-radius: 8px;
      background-color: rgb(245, 245, 245);
    }
  }
}
.qr-code-url {
  color: #606266;
}
</style>

